import { Outlet } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { getResultadosCulturaSecond } from 'services/dashboard.service';
import Avatar from 'funifier-nice-avatar';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

import { Colaboracao, FocoNoCliente, Inovacao, Lideranca } from 'components/icons';
import { IconPlus } from 'components/rebrand/icons';
import { dimensaoByBehavior } from 'components/rebrand/mappings';
import { BehaviorLabel, GetBehaviorDescription, GetBehaviorTextDestaque } from 'utils/strings';
import { DestaquesCulturaDetail } from './detail';
import ReactPaginate from 'react-paginate';

const release = true;

const DIMENSION_FILTERS = [
  { id: '', label: 'Todos' },
  { id: 'cooperacao', label: 'Cooperação' },
  { id: 'iniciativa', label: 'Iniciativa' },
  { id: 'integridade', label: 'Integridade' },
  { id: 'lideranca', label: 'Liderança Inspiradora' },
];

// const options: any = [{ value: 0, label: 'Ciclo 1/2023' }];

interface DestaqueCulturaProps {
  showHead: (item: boolean) => void;
  options: any;
}

function typeText() {
  return <></>;
  // return (
  //   <p>
  //     Para ser um Destaque da Cultura em uma das dimensões Colaboração, Inovação, Foco no Cliente, Proatividade ou Liderança
  //     Engajadora e ser premiado com 2.000 (dois mil) gigabytes e Selo no Humanograma, você precisa:
  //     <br /> <br />
  //     Alcançar no mínimo 5 (cinco) reconhecimentos na respectiva dimensão do comportamento;
  //     <br /> <br />
  //     Não estar no nível Iniciante; e Não estar no nível Iniciante;
  //     <br /> <br />
  //     Estar com a pontuação dentre as 5% melhores do seu grupo em uma das Dimensões da Cultura.
  //     <br />
  //     <br />A divulgação dos classificados na dinâmica Destaques da Cultura será realizada por ordem alfabética. Apenas você pode
  //     visualizar sua pontuação.
  //   </p>
  // );
}

export default function DestaquesCultura({ showHead, options }: DestaqueCulturaProps) {
  const [list, setList] = useState<unknown[]>();
  const [page, setPage] = useState(0);
  const [activePag, setActivePag] = useState(0);
  const [loadingList, setLoadingList] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [showDetail, setShowDetail] = useState<any>('');
  const [selectedValue, setSelectedValue] = useState('');
  const [isMounted, setIsMounted] = useState(false);

  const behaviorsItem = [
    {
      id: 'cooperacao',
      icon: <Colaboracao size={'100%'} />,
    },
    {
      id: 'integridade',
      icon: <FocoNoCliente size={'100%'} />,
    },
    {
      id: 'iniciativa',
      icon: <Inovacao size={'100%'} />,
    },
    {
      id: 'lideranca',
      icon: <Lideranca size={'100%'} />,
    },
  ];

  const [mask] = useState('');

  const searchRef = useRef<any>();

  function handleDetail(item: any) {
    setShowDetail(item);
  }

  const handleChange = (event: any) => {
    setSelectedValue(event.target.value ? event.target.value : '');
  };

  async function loadData(e?: any, itemPage?: number, clear?: boolean) {
    if (!options?.value) return;

    if (e) {
      e.preventDefault();
    }

    if (clear) {
      setSelectedValue('');
    }

    try {
      const rangeItem = itemPage ? itemPage * 20 : 0;

      setActivePag(itemPage ? itemPage : 0);
      setLoadingList(true);
      setList([]);

      const data = await getResultadosCulturaSecond(
        searchRef.current.value,
        selectedValue ? selectedValue : undefined,
        rangeItem,
        options?.value,
      );

      setPage(data.range.pages);
      setList(data.result);
      setLoadingList(false);
    } catch (e) {}
  }

  useEffect(() => {
    if (searchRef.current) {
      searchRef.current.value = '';
    }

    if (!!options) {
      loadData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, selectedValue, options]);

  useEffect(() => {
    showHead(!!showDetail);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDetail]);

  if (!!showDetail)
    return (
      <DestaquesCulturaDetail
        onClose={() => setShowDetail('')}
        behavior={showDetail.behavior}
        id={showDetail.matricula}
        grupo={showDetail.grupo}
        funcis={showDetail.membros}
        active={options}
      />
    );

  const selectedBehaviorItem = behaviorsItem.find(item => item.id === selectedValue);

  return (
    <>
      <div>
        <form className="rb-destaque__search" onSubmit={e => loadData(e, 0, false)}>
          <input
            className="rb-input"
            placeholder="Pesquise por nome ou matrícula"
            ref={(ref: any) => (searchRef.current = ref)}
            inputMode="search"
          />
          <button type="submit" className="rb-btn-primary">
            Buscar
          </button>
        </form>

        <p className="rb-destaque__filter-label" tabIndex={0}>
          Filtre por dimensão do comportamento
        </p>
        <div className="rb-destaque__filters">
          {DIMENSION_FILTERS.map(filter => (
            <button
              key={filter.id || 'all'}
              type="button"
              className={`rb-toggle ${selectedValue === filter.id ? 'rb-toggle--on' : 'rb-toggle--off'}`}
              onClick={() => setSelectedValue(filter.id)}
            >
              {filter.label}
            </button>
          ))}
        </div>

        {!!selectedBehaviorItem && (
          <div className="rb-panel rb-destaque__desc">
            <div className="rb-destaque__desc-icon">{selectedBehaviorItem.icon}</div>
            <div className="rb-destaque__desc-text">
              <p className="rb-destaque__desc-lead">{GetBehaviorDescription(selectedBehaviorItem.id)}</p>
              <div dangerouslySetInnerHTML={{ __html: GetBehaviorTextDestaque(selectedBehaviorItem.id) }} />
            </div>
          </div>
        )}

        {release && (
          <>
            {loadingList && (
              <div className="rb-hero-grid">
                {[0, 1, 2, 3].map(i => (
                  <div key={i} className="rb-skeleton" style={{ height: 280 }} />
                ))}
              </div>
            )}

            {!loadingList && list?.length === 0 && <div className="rb-empty">Nenhum resultado encontrado.</div>}

            {!loadingList && !!list?.length && (
              <div className="rb-hero-grid">
                {list.map((item: any, index) => {
                  const dimensao = dimensaoByBehavior(item.behavior);
                  return (
                    <div
                      key={item?._id + '-' + item.behavior + index}
                      className="rb-hero rb-rise"
                      style={{ ['--acc' as any]: dimensao.color, ['--acc-glow' as any]: 'rgba(26,171,227,.5)' }}
                      onClick={() => handleDetail(item)}
                      role="button"
                      tabIndex={0}
                      aria-label={`${item.nome} - ${item.diretoria} - ${item.funcao} - ${item.matricula} - Grupo: ${item.grupo}`}
                    >
                      <div className="rb-hero__inner">
                        <div className="rb-hero__avatar">
                          <div className="rb-hero__avatar-ring rb-galcard__avatar">
                            {item.avatar_type ? (
                              item.image ? (
                                <img src={item.image} alt={item.nome} className="rb-galcard__img" />
                              ) : (
                                <span>{item.nome?.[0]}</span>
                              )
                            ) : item.avatar ? (
                              <Avatar className="rb-galcard__img" {...item.avatar} />
                            ) : (
                              <span>{item.nome?.[0]}</span>
                            )}
                          </div>
                        </div>
                        <div className="rb-hero__name">{item.nome}</div>
                        <div className="rb-hero__role">{item.diretoria}</div>
                        <div className="rb-galcard__meta">{item.funcao}</div>
                        <div className="rb-galcard__meta">Matrícula {item.matricula}</div>
                        <div className="rb-hero__dimchip">
                          <span
                            className="rb-dimchip rb-dimchip--dark"
                            style={{ color: dimensao.color, boxShadow: `inset 0 0 0 1.5px ${dimensao.color}` }}
                          >
                            <span className="rb-dimchip__dot" style={{ background: dimensao.color }} />
                            {BehaviorLabel[item.behavior]}
                          </span>
                        </div>
                        <div className="rb-hero__spacer" />
                        <button type="button" className="rb-vermais">
                          <IconPlus size={15} /> Ver mais
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {page > 1 && (
              <div className="rb-pagination">
                <ReactPaginate
                  activeClassName={'item active '}
                  breakClassName={'item break-me '}
                  breakLabel={'...'}
                  containerClassName={'pagination'}
                  disabledClassName={'disabled-page'}
                  nextClassName={'item next '}
                  pageClassName={'item pagination-page '}
                  previousClassName={'item previous'}
                  initialPage={0}
                  forcePage={activePag}
                  nextLabel={<IoIosArrowForward style={{ fontSize: 18 }} />}
                  onPageChange={data => loadData(null, data.selected)}
                  pageRangeDisplayed={3}
                  pageCount={page}
                  previousLabel={<IoIosArrowBack style={{ fontSize: 18 }} />}
                />
              </div>
            )}
          </>
        )}
      </div>
      <Outlet />
    </>
  );
}
